export default {
  errors: {
    googleNotAvailable: 'El acceso con Google aún no está disponible para esta cuenta. Para continuar, ingrese su contraseña',
  },
  login: {
    form: {
      email: {
        placeholder: 'Ingrese su correo',
      },
      password: {
        placeholder: 'Ingrese su contraseña',
      },
    },
  },
  register: {
    form: {
      email: {
        placeholder: 'Ingrese su correo',
      },
      password: {
        placeholder: 'Ingrese una contraseña',
      },
      coupon: {
        label: '¿Tiene un código promocional?',
        placeholder: 'Ingréselo aquí',
      },
      googleButton: 'Regístrese con Google',
    },
    footer: {
      haveAccount: '¿Ya tiene una cuenta?',
      login: 'Inicie sesión',
    },
  },
  registerEducationAlliance: {
    title: '¡Aquí empieza su alianza educativa con Alegra! 🎓',
    form: {
      information: {
        description:
          'Si no pertenece a una alianza educativa o desea usar Alegra para su negocio, cree una cuenta ',
      },
    },
  },
  validateIdentity: {
    request: {
      options: {
        whatsapp: {
          placeholder: 'Le enviaremos un código de seguridad a su número de WhatsApp.',
        },
        email: {
          placeholder: 'Le enviaremos un código de seguridad a su correo electrónico principal.',
        },
      },
    },
    requestWhatsApp: {
      description: 'Ingrese los últimos 4 dígitos de su número de WhatsApp.',
    },
    otp: {
      title: 'Ingrese el código de seguridad',
      description: {
        whatsapp: 'Revise su WhatsApp e ingrese el código de 6 dígitos.',
        email: 'Revise el correo {email} e ingrese el código de 6 dígitos para continuar.',
      },
      errorCode: 'El código es incorrecto. Intente nuevamente o solicite uno nuevo.',
    },
    temporarilyBlocked: {
      description:
        'Por su seguridad, hemos suspendido el acceso después de 3 intentos fallidos. Por favor, contacte a soporte para ingresar a su cuenta.',
      options: {
        email: {
          label: 'Escríbanos por correo',
        },
        chat: {
          label: 'Hable con un agente',
          placeholder: 'Nuestro equipo le atenderá de lunes a viernes de {start} a {end}.',
        },
      },
      info: 'Este bloqueo es <b>temporal</b>. Su información sigue 100% protegida en Alegra.',
    },
  },
}
